import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface InitiateIndividualConversationData {
  participantAccountId: string
  message?: string
}

interface InitiateIndividualConversationResponse {
  id: string
}

const initiateIndividualConversation = async (
  data: InitiateIndividualConversationData
): Promise<InitiateIndividualConversationResponse> => {
  const { data: responseData } = await api.post<InitiateIndividualConversationResponse>(
    '/conversations/individual',
    {
      participantAccountId: data.participantAccountId,
      ...(data.message && { message: data.message }),
    }
  )
  return responseData
}

export const useInitiateIndividualConversation = () => {
  const queryClient = useQueryClient()

  return useMutation<InitiateIndividualConversationResponse, Error, InitiateIndividualConversationData>({
    mutationFn: initiateIndividualConversation,
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['conversations'] }),
        queryClient.invalidateQueries({ queryKey: ['messages', response.id] }),
      ])
    },
  })
}

